import { FC } from "react";
import { Table as BaseTable, TableProps } from "baseui/table-semantic";
import { tableOverrides } from "@components/base/table/overrides";

const Table: FC<TableProps & { divider?: "vertical" | "horizontal" }> = ({
  divider = "vertical",
  ...props
}) => {
  return (
    <BaseTable
      divider={divider}
      {...props}
      overrides={{ ...tableOverrides, ...props.overrides }}
    />
  );
};

export default Table;
